import { Directive, OnInit, ViewContainerRef, Input } from '@angular/core';

import { Validator, ValidatorBase } from '../core/model';

@Directive(
    {
        selector: "[phone-validator]",
        host: { '(change)': 'changed($event)' },
        exportAs: 'validator'
    }
)
export class PhoneValidatorDirective extends ValidatorBase implements Validator
{
    @Input('phone-validator')
    public getValue: () => string;

    @Input('view')
    public phonePart: 'country-code' | 'phone-number' = 'phone-number';

    public constructor(viewRef: ViewContainerRef)
    {
        super(viewRef);
    }

    public changed($event: any): void
    {
        this.validate();
    }

    protected isValid(): boolean
    {
        const elementValue = this.element.value;
        if (elementValue == null || elementValue.length === 0)
        {
            return false;
        }

        if (this.phonePart === 'country-code')
        {
            return /^[0-9]{2}$/.test(elementValue);
        }

        return /^[0-9]{1,}$/.test(elementValue.length);
    }
}
